export const voiceCalls = {
  "head": {
    "title": "Llamadas",
    "subtitle": "Las llamadas que ha atendido tu recepción telefónica."
  },
  "stats": {
    "all": "llamada | llamadas",
    "spoken": "hablada | habladas",
    "inTotal": "en total"
  },
  "toolbar": {
    "searchLabel": "Buscar",
    "searchPlaceholder": "Teléfono de quien llamó…",
    "clear": "Borrar la búsqueda",
    "showLabel": "Mostrar",
    "showAll": "Todas las llamadas",
    "showSpoken": "Solo las que se hablaron",
    "showRecorded": "Solo las grabadas"
  },
  "notice": {
    "noRecording": "Las llamadas no se están grabando.",
    "noRecordingHow": "Enciende «Grabar llamadas» en los ajustes de tu recepción telefónica y, a partir de ahí, podrás escucharlas y transcribirlas desde aquí."
  },
  "empty": {
    "title": "Todavía no te ha llamado nadie",
    "text": "Cuando alguien llame a tu número de recepción, la llamada aparecerá aquí con quién llamó, cuánto duró y qué quería.",
    "filteredTitle": "No hay llamadas con ese filtro",
    "filteredText": "Prueba a quitar la búsqueda o los filtros de arriba."
  },
  "item": {
    "notSpoken": "No llegaron a hablar",
    "unknownCaller": "Número oculto",
    "linkSent": "Se le mandó el enlace de reserva",
    "play": "Escuchar la grabación",
    "pause": "Pausar",
    "showTranscript": "Ver la transcripción",
    "hideTranscript": "Ocultar la transcripción",
    "transcribe": "Transcribir y resumir",
    "transcribing": "Transcribiendo…",
    "noRecordingShort": "Esta llamada no se grabó",
    "viewReservation": "Ver la reserva",
    "noSummary": "Esta llamada no tiene resumen.",
    "copy": "Copiar el número",
    "copied": "Copiado"
  },
  "errors": {
    "load": "No se pudieron cargar las llamadas.",
    "play": "No se pudo reproducir la grabación.",
    "transcribe": "No se pudo pedir la transcripción."
  },
  "table": {
    "call": "Llamada",
    "reservation": "Reserva",
    "listing": "Alojamiento",
    "summary": "Resumen",
    "duration": "Duración",
    "date": "Fecha"
  }
};
